import React, { useState } from "react";
import { Button, DatePicker, Form, Radio, Space, Typography } from "antd";
import dayjs from "dayjs";

const SelectExportFormat = ({ selectFormat, participants }: any) => {
  const [isDisabled, setIsDisabled] = useState(true);

  return (
    <div className="w-[95%]  md:w-full h-fit  bg-upload-bg border border-dashed border-upload-border rounded-sm mt-12 md:mt-0 p-5 pb-[10px]">
      <div className="lg:flex gap-10">
        <div className="lg:w-32">
          <Typography className="mb-4 font-bold">
            Odaberi datum za izvoz prisutnih
          </Typography>
          <Form.Item name="exportPresentParticipants">
            <DatePicker
              className="rounded-sm"
              placeholder="Odaberi"
              allowClear={false}
            />
          </Form.Item>
        </div>
        <div>
          <Typography className="mb-2 font-bold">Odaberi format</Typography>

          <Form.Item name="format">
            <Radio.Group onChange={() => setIsDisabled(false)}>
              <Space direction="vertical">
                <Radio value={".xlsx"}>.xlsx</Radio>
                <Radio value={".csv"}>.csv</Radio>
                <Radio value={".pdf"}>.pdf</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </div>
      </div>
      <Form.Item>
        <Button
          type="primary"
          htmlType="button"
          onClick={selectFormat}
          disabled={
            isDisabled ||
            participants.filter(
              (participant: any) =>
                participant.attendanceDate && participant.status === "Prisutan"
            ).length === 0
          }
          className="bg-custom-pink-900 text-white mt-1 flex items-center justify-center font-medium text-base w-full md:w-[132px] h-10 rounded-sm border-custom-pink-900 shadow"
        >
          IZVEZI
        </Button>
      </Form.Item>
    </div>
  );
};

export default SelectExportFormat;
